<template>
    <layout v-bind:user="user" v-bind:shops="shops" v-bind:brands="brands" v-bind:company="company" title="ダッシュボード">
        <main class="ly_main"><div class="wrap"><div class="inner">

            <!--:::::::::::::::::::::::::::::::::::::::::::::::
                Heading
            :::::::::::::::::::::::::::::::::::::::::::::::::-->
            <h1 class="heading_page-title flex _y-center">
                <div class="main"><span>Dashboard</span></div>
            </h1><!--/.heading_page-title-->

            <!--:::::::::::::::::::::::::::::::::::::::::::::::
                DashBoardCardWrap
            :::::::::::::::::::::::::::::::::::::::::::::::::-->
            <div class="ly_dashboard-card-wrap">

                <!--お知らせ-->
                <div class="row flex _left">
                    <div class="block _min-h">

                        <div class="md_common-bl">

                            <h2 class="title">
                                <p>お知らせ</p>
                                <div class="link">
                                    <a v-bind:href="route(routeNewsList)">MORE</a>
                                </div>
                                <div class="label">News</div>
                            </h2>

                            <!--Inner-->
                            <div class="inner">

                                <ul class="list_common _link" v-for="n in newsList" :key="n.id">

                                    <!-- お知らせ -->
                                    <li v-if="n.type == 0" class="_operating" v-bind:class="{_unread: unread}">
                                        <Link v-bind:href="route(routeNewsDetail, n.id)">
                                            <div class="date"><span>{{formatDate(n.created_at)}}</span></div>
                                            <div class="detail">
                                                <span>{{n.title}}</span>
                                            </div>
                                        </Link>
                                    </li>

                                    <!-- メッセージ -->
                                    <li v-if="n.type == 1 && !n.showroom_id" v-bind:class="{_unread: unread}">
                                        <Link v-bind:href="route(routeTalk)" v-bind:data="{brand_id: n.brand_id, shop_id: n.shop_id}">
                                            <div class="date"><span>{{formatDate(n.created_at)}}</span></div>
                                            <div class="detail">
                                                <span>{{n.message}}</span>
                                            </div>
                                        </Link>
                                    </li>
                                    <li v-if="n.type == 1 && n.showroom_id" v-bind:class="{_unread: unread}">
                                        <Link v-bind:href="route(routeTalk)" v-bind:data="{showroom_id: n.showroom_id, brand_id: n.brand_id}">
                                            <div class="date"><span>{{formatDate(n.created_at)}}</span></div>
                                            <div class="detail">
                                                <span>{{n.message}}</span>
                                            </div>
                                        </Link>
                                    </li>

                                    <!-- MSルーム追加 -->
                                    <li v-if="n.type == 2" v-bind:class="{_unread: unread}">
                                        <a>
                                            <div class="date"><span>{{formatDate(n.created_at)}}</span></div>
                                            <div class="detail">
                                                <span>{{n.message}}</span>
                                            </div>
                                        </a>
                                    </li>

                                </ul>

                            </div><!--/.inner-->

                        </div>
                    </div>
                </div><!--/.row-->

            </div><!--/.ly_dashboard-card-wrap-->
        <AlertModal
            v-if="showAlertModal" 
            @close="closeAlertModal" 
            :title="alert_modal_title" 
            :message="alert_modal_message"
            :mode="alert_modal_mode" 
        />
        </div></div><div class="heading_page-title-en"><span>{{backName}}</span></div></main>
    </layout>
</template>
<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import Pagination from '@/components/Admin/Pagination'
    import dayjs from 'dayjs'
    import { Link } from '@inertiajs/inertia-vue3'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'

    export default {
        components: {
            "layout": AdminLayout,
            "Link": Link,
            "AlertModal": AlertModal,
        },
        data() {
            return {
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: ''
            }
        },
        props:{
            news: Object,
            user: Object,
            company: Object,
            brands: Object,
        },
        mounted() {
            if(this.$page.props.flash.success?.length > 0){
                const successMessage = this.$page.props.flash.success.split(",");
                this.openAlertModal("success", successMessage[0], successMessage[1]);
            }
        },
        methods: {
            formatDate: dateStr => dayjs(dateStr).format('YYYY/MM/DD'),
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            },
        },
        computed: {
            backName() {
                if (this.user.type == 0) {
                    return 'Admin';
                } else if (this.user.type == 1) {
                    return 'Shop';
                } else if (this.user.type == 2) {
                    return 'Brand';
                } else if (this.user.type == 3) {
                    return 'ShowRoom';
                }
            },
            newsList() {
                return this.news;
            },
            routeNewsList() {
                var url = location.pathname;
                if (url.indexOf( '/brand/' ) != -1) {
                    return 'admin.brand.news';
                } else if (url.indexOf( '/showroom/' ) != -1) {
                    return 'admin.showroom.news';
                }
            },
            routeNewsDetail() {
                var url = location.pathname;
                if (url.indexOf( '/brand/' ) != -1) {
                    return 'admin.brand.news.detail';
                } else if (url.indexOf( '/showroom/' ) != -1) {
                    return 'admin.showroom.news.detail';
                }
            },
            routeTalk() {
                var url = location.pathname;
                if (url.indexOf( '/brand/' ) != -1) {
                    return 'admin.brand.talk';
                } else if (url.indexOf( '/showroom/' ) != -1) {
                    return 'admin.showroom.talk';
                }
            },
        },
    }
</script>
